import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { RefCultureBio } from 'src/app/data/declaration/models/ref-culture-bio.model';
import { RefCultureBioService } from 'src/app/data/declaration/services/parcellaire/ref-culture-bio.service';
import { LoaderService } from '../../../../../../../../core/services/loader/loader.service';

@Component({
    selector: 'app-edit-culture-bio',
    templateUrl: './edit-culture-bio.component.html',
    styleUrls: ['./edit-culture-bio.component.scss'],
    standalone: false
})
export class EditCultureBioComponent implements OnInit {
    formGroup: UntypedFormGroup;
    creation = false;
    title: string;
    cultureBio: RefCultureBio;

    get code() {
        return this.formGroup.get('code');
    }
    get libelle() {
        return this.formGroup.get('libelle');
    }

    constructor(
        private readonly fb: UntypedFormBuilder,
        private readonly loaderService: LoaderService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly cultureBioService: RefCultureBioService
    ) {}

    ngOnInit() {
        const id = parseInt(this.route.snapshot.paramMap.get('id'), 10);

        if (!id) {
            this.creation = true;
        }
        this.loadData(id);
    }

    loadData(id: number) {
        this.title = this.creation ? 'page.valeur_parametrable.form.title.add_culture_bio' : 'page.valeur_parametrable.form.title.edit_culture_bio';

        if (this.creation) {
            this.cultureBio = new RefCultureBio();
            this.initForm(null);
        } else {
            this.cultureBioService
                .getRefCultureBio()
                .pipe(this.loaderService.operator())
                .subscribe(gels => {
                    this.cultureBio = gels.find(g => g.id === id);
                    this.initForm(this.cultureBio && this.cultureBio.id ? this.cultureBio : null);
                });
        }
    }

    private initForm(gel?: RefCultureBio): void {
        this.formGroup = this.fb.group({
            code: [{ value: gel ? gel.code : undefined, disabled: false }, Validators.required],
            libelle: [{ value: gel ? gel.libelle : undefined, disabled: false }, Validators.required]
        });
    }

    submit() {
        if (this.formGroup.valid) {
            this.cultureBio.code = this.code.value;
            this.cultureBio.libelle = this.libelle.value;

            if (this.cultureBio.id == null) {
                this.cultureBioService.creerRefCultureBio(this.cultureBio).subscribe(idCultureBio => {
                    this.router.navigate(['.'], { relativeTo: this.route.parent });
                });
            } else {
                this.cultureBioService.modifierRefCultureBio(this.cultureBio).subscribe(() => {
                    this.router.navigate(['.'], { relativeTo: this.route.parent });
                });
            }
        }
    }
}
